import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faBookOpen, faHistory, faShoppingCart, faKey, faRightFromBracket ,faTachometerAlt} from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import config from '../functions/config';




const AdminDashboard = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigation = (route) => {
    window.location.href = route;
  };

  return (
    <div className="  min-vh-100">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container-fluid">
        {/* Brand Name */}
        <Link className="navbar-brand" to="/">
          📚 Library 
        </Link>

        {/* Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible Menu */}
        <div className={`navbar-collapse ${isOpen ? "show" : "collapse"}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/success">
                Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/userhome">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/profile">
                Profile
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/rentalhistory">
                Rented Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/purchasehistory">
                Purchase History
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/login" className="btn btn-danger">
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    {/* Hero Section */}
    <div className='heroSection'>
        <div className="container text-center text-success " >
          <Link to="/success" className="btn btn-light btn-lg mt-4 m-5">Explore now !</Link>
        </div>
        
      </div>

      <div className="container   pt-2 justify-content-center">
      {/* Welcome Message */}
      <div className="text-center mb-5">
        <h1 className="display-4 text-primary">📚 Welcome to the Library</h1>
        <p className="lead">Explore a wide variety of books and resources available for you.</p>
      </div>

{/* Types of Books Section */}
<div className="mb-5">
  <h2 className="text-dark ">📖 Types of Books</h2>
  <div className="container">
    <div className="row g-4">
      {[
        { type: 'Fiction', img: 'https://th.bing.com/th/id/OIP.IjXSQgpeek65QTvREX852QAAAA?rs=1&pid=ImgDetMain' },
        { type: 'Non-Fiction', img: 'https://th.bing.com/th/id/OIP.coCC4Dkmsh2jzF17hva_nQHaLJ?rs=1&pid=ImgDetMain' },
        { type: 'Science', img: 'https://schoolbooks.ie/cdn/shop/products/NOS2IJ-1_800x.jpg?v=1659681825' },
        { type: 'History', img: 'https://d28hgpri8am2if.cloudfront.net/book_images/cvr9781439149959_9781439149959_hr.jpg' },
        { type: 'Technology', img: 'https://th.bing.com/th/id/OIP.NTysc_EarHIFpwJW_LsG8AHaLR?rs=1&pid=ImgDetMain' },
        { type: 'Biography', img: 'https://th.bing.com/th/id/OIP.YKMfmtiwurEnx9ertgQg-gHaL6?rs=1&pid=ImgDetMain' },
        { type: 'Fantasy', img: 'https://th.bing.com/th/id/OIP.XS_rPmWeqK0ptfRshJmy7AAAAA?rs=1&pid=ImgDetMain' },
        { type: 'Mystery', img: 'https://th.bing.com/th/id/OIP.uYn5RsobUKsYlRtKo3BFHAHaLH?rs=1&pid=ImgDetMain' }
      ].map((book, index) => (
        <div key={index} className="col-10 col-sm-6 col-md-4 col-lg-2">
          <div className="card shadow-sm h-100">
            <img src={book.img} className="card-img-top" alt={`${book.type} Books`} />
            <div className="card-body text-center">
              <h5 className="card-title text-primary">{book.type}</h5>
              <p className="card-text">Explore {book.type} books from various authors and genres.</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

    {/* Books Published Since Years Ago Section */}
<div className="mb-5">
  <h2 className="text-dark text-center">📅 Books Published Since Recent Years</h2>
  <div className="row row-cols-1 row-cols-md-5 g-4 justify-content-center">
    {[2023, 2022, 2021, 2020, 2019].map((year, index) => (
      <div key={index} className="col d-flex justify-content-center">
        <div className="card shadow-sm h-100 text-center">
          <div className="card-body">
            <h5 className="card-title text-success">Year {year}</h5>
            <p className="card-text">Browse books published in {year}.</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

{/* Manager's Recommendations Section */}
<div className="mb-5">
  <h2 className="text-dark text-center">👨‍💼 Manager's Recommendations</h2>
  <div className="row row-cols-1 row-cols-md-5 g-4 justify-content-center">
    {['To Kill a Mockingbird', '1984', 'The Great Gatsby', 'Pride and Prejudice'].map((book, index) => (
      <div key={index} className="col d-flex justify-content-center">
        <div className="card shadow-sm h-100 text-center">
          <div className="card-body">
            <h5 className="card-title text-info">{book}</h5>
            <p className="card-text">Recommended by our library manager for all users.</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

{/* Popular Authors Section */}
<div className="mb-5">
  <h2 className="text-dark text-center">👩‍🎨 Popular Authors</h2>
  <div className="row row-cols-1 row-cols-md-5 g-4 justify-content-center">
    {['J.K. Rowling', 'George Orwell', 'Jane Austen', 'Agatha Christie'].map((author, index) => (
      <div key={index} className="col d-flex justify-content-center">
        <div className="card shadow-sm h-100 text-center">
          <div className="card-body">
            <h5 className="card-title text-warning">{author}</h5>
            <p className="card-text">Discover the best works by {author}.</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

{/* Latest Arrivals Section */}
<div className="mb-5">
  <h2 className="text-dark text-center">📚 Latest Arrivals</h2>
  <div className="row row-cols-1 row-cols-md-5 g-4 justify-content-center">
    {['The Silent Patient', 'Where the Crawdads Sing', 'The Midnight Library', 'Project Hail Mary'].map((book, index) => (
      <div key={index} className="col d-flex justify-content-center">
        <div className="card shadow-sm h-100 text-center">
          <div className="card-body">
            <h5 className="card-title text-danger">{book}</h5>
            <p className="card-text">Check out the latest additions to our collection.</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

{/* Top-Rated Books Section */}
<div className="mb-5">
  <h2 className="text-dark text-center">⭐ Top-Rated Books</h2>
  <div className="row row-cols-1 row-cols-md-5 g-4 justify-content-center">
    {['The Hobbit', 'The Catcher in the Rye', 'The Alchemist', 'Harry Potter Series'].map((book, index) => (
      <div key={index} className="col d-flex justify-content-center">
        <div className="card shadow-sm h-100 text-center">
          <div className="card-body">
            <h5 className="card-title text-dark">{book}</h5>
            <p className="card-text">These books have been rated highly by our readers.</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

    </div>


  
     {/* Dashboard Cards */}
<div className="container justify-content-center">
  <div className="row row-cols-1 row-cols-md-4 justify-content-center">
    
    {/* Profile View Card */}
    <div className="col mt-4">
      <div className="card shadow-lg border-primary" onClick={() => handleNavigation('/profile')}>
        <div className="card-body text-center p-4">
          <FontAwesomeIcon icon={faUser} size="2x" className="mb-3 text-primary" />
          <h5 className="card-title text-primary">Profile View</h5>
          <p className="card-text ">View and update your profile information.</p>
        </div>
      </div>
    </div>

    {/* Books View Card */}
    <div className="col mt-4">
      <div className="card shadow-lg border-success" onClick={() => handleNavigation('/success')}>
        <div className="card-body text-center p-4">
          <FontAwesomeIcon icon={faBookOpen} size="2x" className="mb-3 text-success" />
          <h5 className="card-title text-success">Books View</h5>
          <p className="card-text ">Browse and manage the library's collection of books.</p>
        </div>
      </div>
    </div>

    {/* Rental History Card */}
    <div className="col mt-4">
      <div className="card shadow-lg border-danger" onClick={() => handleNavigation('/rental-history')}>
        <div className="card-body text-center p-4">
          <FontAwesomeIcon icon={faHistory} size="2x" className="mb-3 text-danger" />
          <h5 className="card-title text-danger">Rental History</h5>
          <p className="card-text">Track your rental activities, including start dates and due dates.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="row row-cols-1 row-cols-md-4 mt-3 g-4 justify-content-center">
    
    {/* Purchase History Card */}
    <div className="col">
      <div className="card shadow-lg border-warning" onClick={() => handleNavigation('/purchase-history')}>
        <div className="card-body text-center p-4">
          <FontAwesomeIcon icon={faShoppingCart} size="2x" className="mb-3 text-warning" />
          <h5 className="card-title text-warning">Purchase History</h5>
          <p className="card-text ">Track your purchase history, including payment statuses.</p>
        </div>
      </div>
    </div>

    {/* Password Change Card */}
    <div className="col">
      <div className="card shadow-lg border-info" onClick={() => handleNavigation('/change-password')}>
        <div className="card-body text-center p-4">
          <FontAwesomeIcon icon={faKey} size="2x" className="mb-3 text-info" />
          <h5 className="card-title text-info">Password Change</h5>
          <p className="card-text ">Change your account password for security.</p>
        </div>
      </div>
    </div>

    {/* Logout Card */}
    <div className="col">
      <div className="card shadow-lg border-secondary" onClick={() => handleNavigation('/login')}>
        <div className="card-body text-center p-4">
          <FontAwesomeIcon icon={faRightFromBracket} size="2x" className="mb-3 text-secondary" />
          <h5 className="card-title text-secondary">Logout</h5>
          <p className="card-text">Logout from your account and end your session.</p>
        </div>
      </div>
    </div>

  </div>
</div>


      {/* Dashboard Footer */}
      <div className="container text-center mt-5">
        <p className="text-muted">© 2025 Library Management System. All rights reserved.</p>
      </div>

      <style jsx>{`
        body {
          position: relative;
          margin: 0;
          padding: 0;
        }

        body::before {
          content: '';
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: url('https://i.ytimg.com/vi/wPPXPx9S_Ms/maxresdefault.jpg') no-repeat center center fixed;
          background-size: cover;
          opacity: 0.1;
          z-index: -1;
        }

        .content {
          margin-left: 200px;
        }

        @media (max-width: 768px) {
          .vertical-nav {
            width: 100%;
          }
          .content {
            margin-left: 0;
          }
        }



        h1, h2, h3, h4, h5, h6 {
          font-family: "Times New Roman", Times, serif;
          color: #1a1a1a;
        }


          .fixed-buttons {
          position: fixed;
          top: 150px;
          right: 50px;
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .fixed-buttons button {
          border-radius: 50px;
          padding: 10px 20px;
          font-size: 16px;
          color: #fff;
          border: none;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          transition: transform 0.2s;
        }

        .fixed-buttons button:hover {
          transform: scale(1.1);
        }

        .btn-primary {
          background-color: #007bff;
        }

        .btn-success {
          background-color: #28a745;
        }

        .btn-warning {
          background-color: #ffc107;
        }

        .btn-danger {
          background-color: #dc3545;
        }

        .btn-dark {
          background-color: #343a40;


      }



      /* Hide buttons on smaller screens */
@media (max-width: 768px) {
  .fixed-buttons {
    display: none;
  }
}
  .heroSection {
              background: url('https://premierimmigration.com/wp-content/uploads/2015/10/cropped-hjj-1.jpg') no-repeat center center fixed;

    color: white;
    padding: 120px 0;
    textAlign: center;
  },
      `}</style>
    </div>
  );
};

export default AdminDashboard;
